
<template>

    <setup_content :title="`Подбор объектов-аналогов для расчета ${data.with_season_factors ? 'с учетом фактора сезонности' : 'без учета фактора сезонности'}`" class="main-container">
		<set_search_analogues ref="set_search_analogues" :id="id" :raw_data="data.filter" v-on:need_refresh="() => { refresh() ; $emit('need_refresh'); }"/>

        <template v-slot:buttons>
            <div class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button variant="outline-primary-secondary" v-if="check_roles([ 'model' ])"
                        @click="() => set_with_season_factors(!data.with_season_factors)"
                    >
                    <span>Подобрать для расчета {{!data.with_season_factors ? 'с учетом фактора сезонности' : 'без учета фактора сезонности'}}</span>
                    <base-icon name="filter_alt" size="md" />
                </b-button>

                <b-button variant="outline-primary-secondary"
                    @click="execute_set_search_analogues"
                >
                    <span>Настройки подбора</span><base-icon name="settings" size="md" />
                </b-button>
            </div>
        </template>

		<b-row>

			<b-col cols="6">

				<h4>Распределение потенциальной арендной платы по типу сезона</h4>

				<scatter_plot ref="scatter_plot" :group_id="group_id"
					title="Распределение потенциальной арендной платы по типу сезона"
					bad_attr_key="bad_profit" :query="additional_query"
					with_zoom with_x_axis_title
					x_attr_key="attrs.season" y_attr_key="attrs.rent_price"
					v-on:need_refresh="() => refresh()"
					:seq_x="[ 'Низкий сезон', 'Средний сезон', 'Высокий сезон', 'Сезон не указан' ]"
				/>

			</b-col>
			<b-col>

				<stat
					ref="stat_plot"
					:group_id="group_id"
					:query="additional_query"
					:mean_type="data.mean_type"
					v-on:set_value="(value) => $emit('set_value', 'mean_type', value)"
					:has_oks="has_oks"
				/>

			</b-col>

		</b-row>

		<elements
			v-if="group_id"
			ref="objects"
			:service="service"
			style="flex: 1;"
			:postfix_for_storage_name="'capitalization_' + id"
			without_add
			:attrs="attrs"
			:raw_query="{ group : group_id }"
			:additional_query="additional_query"
			not_able_for_delete
			with_filters
			essence_name_genetive_case="объекта-аналога"
			essence_name_for_plural_1="объект-аналог"
			essence_name_for_plural_234="объекта-аналога"
			essence_name_for_plural_others="объектов-аналогов"
			without_back_button
			initial_per_page="5"
			initial_sort_by="current_version.attrs.name_profitable"
			:initial_sort_desc="false"
			elements_table_height="25vh"
		>

			<template v-slot:title>

				<h4>Объекты-аналоги</h4>

			</template>

			<template v-slot:nav_items_before_export>

				<b-button v-if="check_roles([ 'model' ])" v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary" title="Исключить объекты-аналоги из расчета" v-on:click="exclude_many">

					<base-icon name="delete" />

				</b-button>
				<b-button v-if="check_roles([ 'model' ])" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright title="Вернуть в исходное состояние" v-on:click="$refs.scatter_plot.reset_state">
					
					<base-icon name="broomstick" />
				
				</b-button>

			</template>

			<template v-slot:table_cell_params="cell">

				<span v-if="cell.data.field.key == 'current_version.attrs.bad_profit'">

					<b-form-checkbox v-if="cell.data.field.key == 'current_version.attrs.bad_profit'" :disabled="!check_roles([ 'model' ])" :checked="! cell.data.item.current_version.attrs.bad_profit" v-on:input="value => set_not_excluded(cell.data.item.id, value)"/>
				
				</span>

			</template>

		</elements>

    </setup_content>

</template>

<script>

import api from "../../../../../../../api"
import setup_content from "../../../setup_assets/content"
import scatter_plot from "../../scatter_plot"
import stat from "./stat"
import set_search_analogues from "./set_search_analogues"
import elements from "../../../../../../elements"
import variables from "../../../../../../../api/variables"

export default {

    props :
	{
		id : String,
		data : Object,
		attr : String,
        objects_count : Number,
        active_step : String,
		group_id : String,
		has_oks : Boolean
	},

	components :
	{
		scatter_plot,
        setup_content,
        // setup_frame,
        // statistic,
        stat,
        set_search_analogues,
		elements,
	},

	watch :
	{
		data :
		{
			immediate : true,
			deep : true,

			handler(data)
			{
				if(data)
				{
					// Закомментировано, чтобы фильтр по периодичности тоже обновлялся
					// if(data.with_season_factors != this.prev_with_season_factors)
					{
						this.prev_with_season_factors = data.with_season_factors

						var additional_query = api.deep_clone(this.base_additional_query)

						if(data.with_season_factors)
						{
							additional_query["current_version.attrs.season"] = { "$exists" : true }
						}

						var or = []

						Object.entries(data.filter).forEach(
							elem =>
							{
								if(elem[1].state)
								{
									or.push({
										"current_version.attrs.period" : variables.periods.types[elem[0]].label,
										"current_version.attrs.period_count" : Number(elem[1].period_count)
									})
								}
							})

						if(or.length)
						{
							additional_query["$or"] = or
						}

						this.additional_query = additional_query

						if(this.$refs.scatter_plot)
						{
							this.$refs.scatter_plot.objects.query = additional_query
							this.$refs.scatter_plot.query = additional_query
						}

						if(this.$refs.stat_plot)
							this.$refs.stat_plot.query = additional_query

						if(this.$refs.objects)
						{
							this.$refs.objects.additional_query = additional_query

							this.$refs.objects.refresh(1, true)
						}
					}

					if(this.$refs.scatter_plot)
						this.$refs.scatter_plot.refresh()

					if(this.$refs.stat_plot)
						this.$refs.stat_plot.set_chart()
				}
			}
		}
	},

    data()
    {
		var attr_key
		var attrs =
		[
			{
				attr_key : "attrs.bad_profit",
				label : "Учитывать при подборе",
				visible : true,
				visible_if_no_visible : true,
				bool_reverse : true,
				params : true,
			},
			{
				attr_key : "attrs.group_code",
				visible : true,
				visible_if_no_visible : true,
			},
			{
				attr_key : "attrs.period",
				visible : true,
				visible_if_no_visible : true,
			},
			{
				attr_key : "attrs.period_count",
				visible : true,
				visible_if_no_visible : true,
			},
			{
				attr_key : "attrs.season",
				visible : true,
				visible_if_no_visible : true,
			},
			{
				attr_key : "attrs.corrected_price",
				visible : false,
			},
		]

		if(api.has_oks())
		{
			attrs.push(
			{
				attr_key : "attrs.dimension",
				visible : false,
			})

			attrs.push(
				{
					attr_key : "attrs.uprs",
					visible : true,
					visible_if_no_visible : true,
				})
		}
		else
			attrs.push(
				{
					attr_key : "attrs.corrected_price",
					visible : true,
					visible_if_no_visible : true,
				})

		attrs.push(
			{
				attr_key : "attrs.rent_price",
				visible : true,
				visible_if_no_visible : true,
			})

		if(this.attr == "Площадь, м2")
		{
			attr_key = "current_version.attrs.area_profitable"
			attrs.push(
				{
					attr_key : "attrs.area_profitable",
					visible : false,
				})
		}
		else if(this.attr == "Полезная (арендопригодная) площадь, м2")
		{
			attr_key = "current_version.attrs.useful_area"
			attrs.push(
				{
					attr_key : "attrs.useful_area",
					visible : false,
				})
		}
		else if(this.attr == "Объем, м3")
		{
			attr_key = "current_version.attrs.volume_key_parameter"
			attrs.push(
				{
					attr_key : "attrs.volume_key_parameter",
					visible : false,
				})
		}
		else if(this.attr == "Койко-место, шт.")
		{
			attr_key = "current_version.attrs.beds"
			attrs.push(
				{
					attr_key : "attrs.beds",
					visible : false,
				})
		}
		else if(this.attr == "Номер, шт.")
		{
			attr_key = "current_version.attrs.hotel_number_count"
			attrs.push(
				{
					attr_key : "attrs.hotel_number_count",
					visible : false,
				})
		}
		
		var additional_query = { "current_version.attrs.analogue_profitable_type" : "Аренда", "$and" : [] }
		var desc_1 = {}
		var desc_2 = {}

		desc_1[attr_key] = { "$exists" : true }
		desc_2[attr_key] = { "$ne" : null }

		additional_query["$and"].push(desc_1)
		additional_query["$and"].push(desc_2)

        return {

			service : "cadastral_analogues",
			attrs : attrs,
			base_additional_query : additional_query,
			additional_query : additional_query,
			prev_with_season_factors : null,

        }
    },

    methods :
    {
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },

		refresh(with_scatter_plot = true, with_objects = true, with_stat_plot = true)
		{
			if(with_objects && this.$refs.objects)
				this.$refs.objects.refresh()

			if(with_scatter_plot && this.$refs.scatter_plot)
				this.$refs.scatter_plot.refresh()

			if(with_stat_plot && this.$refs.stat_plot)
				this.$refs.stat_plot.set_chart()
		},

        execute_set_search_analogues()
        {
            this.$refs.set_search_analogues.execute(this.$refs.objects.get_query())
        },

		set_with_season_factors(value)
		{
			if(value && this.check_roles([ 'model' ]))
				api.call(this, "cadastral_cost_evaluation", "has_season", { id : this.id },
					response =>
					{
						if(response.has)
							this.$emit('set_value', 'with_season_factors', value)
						else
							api.show_notification(this, "Отсутствуют ОА с данными о сезонности")
					})
			else
				this.$emit('set_value', 'with_season_factors', value)
		},

		set_not_excluded(id, value)
		{
			if (this.check_roles([ 'model' ]))
            {
				api.call(this, this.service, "set_field", { id : id, field : "current_version.attrs.bad_profit", value : ! value }, () => this.refresh(true, false))
			}
		},

		exclude_many()
		{
			if (this.check_roles([ 'model' ]))
            {
				const query = this.$refs.objects.get_query()
	
				api.call(this, this.service, "set_field_many", { field : "current_version.attrs.bad_profit", value : true, query : query }, () => this.refresh())
			}
		},
    }
}
</script>
